export enum AppointmentStatusEnum {
    Pending = 1,
    Approved = 2,
    Cancelled = 3,
    Rejected = 4,
    Done = 5,
    AppointmentTimeReserved = 6
}